import {
  getProviderIdFromName as databaseProviderIdFromName,
  initialAgents as databaseInitialAgents,
} from "../Database/mock-data";
import {
  getProviderIdFromName as fileStorageProviderIdFromName,
  initialAgents as fileStorageInitialAgents,
} from "../FileStorage/mock-data";
import { ADMIN_DEMO_STORAGE_KEY, type AdminDemoConfig } from "./types";

type ProviderRef = { providerId: string; providerName: string };

function defaultProviderRef(
  agents: ReadonlyArray<{ environment: string; provider: string }>,
  environment: string,
  toId: (name: string) => string,
): ProviderRef | undefined {
  const agent = agents.find((a) => a.environment === environment);
  return agent
    ? { providerId: toId(agent.provider), providerName: agent.provider }
    : undefined;
}

// Defaults derived from each page's seeded agents so the Overview diagram
// shows a populated configuration on first load — before the user has
// explicitly visited the Database or File Storage pages.
function getDefaultConfig(): AdminDemoConfig {
  return {
    database: defaultProviderRef(
      databaseInitialAgents,
      "Development",
      databaseProviderIdFromName,
    ),
    databaseProd: defaultProviderRef(
      databaseInitialAgents,
      "Production",
      databaseProviderIdFromName,
    ),
    fileStorage: defaultProviderRef(
      fileStorageInitialAgents,
      "Development",
      fileStorageProviderIdFromName,
    ),
    fileStorageProd: defaultProviderRef(
      fileStorageInitialAgents,
      "Production",
      fileStorageProviderIdFromName,
    ),
  };
}

export function loadConfig(): AdminDemoConfig {
  const defaults = getDefaultConfig();
  try {
    const raw = localStorage.getItem(ADMIN_DEMO_STORAGE_KEY);
    const stored = raw ? (JSON.parse(raw) as AdminDemoConfig) : {};
    return { ...defaults, ...stored };
  } catch {
    return defaults;
  }
}

export function saveConfig(config: AdminDemoConfig): void {
  try {
    localStorage.setItem(ADMIN_DEMO_STORAGE_KEY, JSON.stringify(config));
  } catch {
    // localStorage may be full or unavailable
  }
}

export function saveConfigSlice<K extends keyof AdminDemoConfig>(
  key: K,
  value: AdminDemoConfig[K],
): AdminDemoConfig {
  const config = loadConfig();
  const next = { ...config, [key]: value };
  saveConfig(next);
  return next;
}
